import React from 'react';

import { ListItem, ListItemButton, ListItemIcon, ListItemText, Radio, Tooltip } from '@mui/material';
import Task from '@mui/icons-material/Task';
import StyledBadge from '../common/StyledBadge';

import ITaskList from '../../types/tasks/ITaskList';


type Props = {
	item: ITaskList,
  checkedId: string,
  isLoading: boolean,
  handleToggle: (value: string) => () => void,
};

export default (props: Props) => {

  const labelId = `checkbox-list-label-${props.item.Id}`;

  return (
    <ListItem 
      key={props.item.Id}
      // secondaryAction={
      //    <CommentIcon />
      // }
      disablePadding
    >
      <ListItemButton disabled={props.isLoading} role={undefined} onClick={props.handleToggle(props.item.Id)} dense>
        <ListItemIcon>
          <Tooltip title='Synchronisiert?' placement='left'>
            <Radio
              checked={props.item.Id === props.checkedId}
              value={props.item.Id}
              name="radio-buttons"
              inputProps={{ 'aria-label': 'A' }}
            />
          </Tooltip>
        </ListItemIcon>
        <div className='row-between-center w-100'>
          <ListItemText id={labelId} primary={props.item.Name} />
          {/* <ListItemText id={labelId} className='text-right text-ellipsis mw-200' secondary={props.item.Id} />  */}
          {props.item.ActivitiesCount > 0 &&
            <Tooltip title='Anzahl der CRM-Aktivitäten' placement='left'>
              <StyledBadge badgeContent={props.item.ActivitiesCount}>
                <Task color='action'/>
              </StyledBadge>
            </Tooltip>
          }
        </div>     
      </ListItemButton>
    </ListItem>
  );
}